
export { CompanySearchInput } from './CompanySearchInput';

// This utility function can be helpful for checking if company register 
// is available without creating a full hook instance
export function isCompanyRegisterAvailable(providers: any[], preferences: any) {
  return Array.isArray(providers) && providers.length > 0 && 
         preferences && !!preferences.defaultProviderId;
}
